var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isInactiveNewLocationModalVisible,
          expression: "isInactiveNewLocationModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-slideout modal-lg" },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "maheading_1" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Add New Location")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "maheading_2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "aria-label": "Close"
                        },
                        on: { click: _vm.closeModal }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "successPanel" }, [
                        _c("div", { staticClass: "col-9" }, [
                          _c("p", { staticClass: "success-msg" }, [
                            _vm._v("Success!")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "success-note" }, [
                            _c("i", { staticClass: "fa fa-check-circle-o" }),
                            _vm._v(
                              "Inactive Account Created\n                                        "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-3 mt-3" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/enterprise/Required_Rocket_Image_106x101.png"),
                              width: "70"
                            }
                          })
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row list_row_margin" }, [
                    _c("div", { staticClass: "col-12 text-center" }, [
                      _c("p", { staticClass: "font-weight-bold" }, [
                        _vm._v("What Happens Now?")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("ul", { staticClass: "list_items" }, [
                        _c("li", [
                          _vm._v("Account can be assigned pre-program users")
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "You can purchase a subscription for the account"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "You can assign the account to users for reporting purposes"
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row gotoBtn justify-content-md-center" },
                    [
                      _c("div", { staticClass: "col-4" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-blue saveBtn text-center",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.openSidebar(_vm.accountId)
                              }
                            }
                          },
                          [_vm._v("Go to Account")]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mt-4 justify-content-md-center" },
                    [
                      _c("div", { staticClass: "col-4" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-blue closeBtn text-center",
                            attrs: { type: "button" },
                            on: { click: _vm.closeModal }
                          },
                          [_vm._v("Close Window")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("EnterpriseAdminOverlaySidebar", {
        ref: "location_sidebar",
        attrs: { isModalVisible: _vm.isModalVisible, readOnly: "" },
        on: { close: _vm.closeSidebar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5a20fd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5a20fd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/inactive_new_location_modal.vue
// module id = null
// module chunks = 